import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DistrictServices from '../../services/DistrictServices';

function AddCity() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const stateId = searchParams.get('stateId');

 
  
  const [cityName, setCityName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    
    try {
      await DistrictServices.addCity({ 
        name: cityName, 
        stateId: stateId 
      });
      navigate(`/cities?id=${stateId}`); 
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add city');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="page-title">
        <div className="title_left">
          <h3>Add New City</h3>
        </div>
      </div>

      <div className="clearfix"></div>

      <div className="row">
        <div className="col-md-12 col-sm-12">
          <div className="x_panel">
            <div className="x_content">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="cityName">City Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="cityName"
                    value={cityName}
                    onChange={(e) => setCityName(e.target.value)}
                    required
                  />
                </div>
                
                {error && <div className="alert alert-danger">{error}</div>}
                
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Adding...' : 'Add City'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCity;